module.exports = __webpack_public_path__ + "static/media/tl.f34c9a01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tl.svg
// module id = 266
// module chunks = 0